exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sortable-chosen {\n    opacity: 0.5;\n    background: #dcdcdc;\n    border-radius: 4px;\n    cursor: grab;\n    border: 3px dashed #7d7979;\n}\n", ""]);

// exports
